import { gql } from "@apollo/client";

export const SET_CURRENT_ORGANIZATION = gql`
  mutation setCurrentOrganization($orgId: String!) {
    setCurrentOrganization(orgId: $orgId) {
      id
      name
      firstName
      lastName
      name
      displayName
      profile_pic
      phoneno
      dob
      isActive
      isEmailVarified
      isUserVerified
      isVerified
      isDeleted
      isForceResetPassword
      email
      roles {
        id
        key
      }
      userOrg {
        id
        isIndividual
        isDeleted
        organization {
          id
          name
          leagalName
          phoneNo
          pin
          email
          isSeller
        }
        isVerified
        roles {
          id
          key
        }
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
      }
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization(
    $locationPhoneNo: String
    $street2: String
    $long: String
    $lat: String
    $cityName: String
    $stateName: String
    $countryName: String
    $street1: String
    $type: String
    $website: String
    $email: String
    $locationName: String
    $name: String!
    $pin: String
    $phoneNo: String
    $leagalName: String
  ) {
    createOrganization(
      locationPhoneNo: $locationPhoneNo
      street2: $street2
      long: $long
      lat: $lat
      cityName: $cityName
      stateName: $stateName
      countryName: $countryName
      street1: $street1
      type: $type
      website: $website
      email: $email
      locationName: $locationName
      name: $name
      pin: $pin
      phoneNo: $phoneNo
      leagalName: $leagalName
    ) {
      id
    }
  }
`;

export const RELOAD_NOTIFICATION = gql`
  subscription($userId: String!) {
    reloadPage(userId: $userId) {
      id
      firstName
      lastName
      name
      displayName
      profile_pic
      phoneno
      dob
      isActive
      isEmailVarified
      isDeleted
      customerType
      isUserVerified
      isForceResetPassword
      email
      roles {
        id
        key
      }
      userOrg {
        isVerified
        isDeleted
        id
        isIndividual
        organization {
          id
          name
          leagalName
          phoneNo
          pin
          email
          isSeller
          website
          locations {
            street1
            street2
            countryName
            stateName
            cityName
            pincode
          }
        }
        roles {
          id
          key
        }
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
        orgSubscriptions {
          id
          subscriptions {
            id
            title
            sellerFee
            feature
          }
        }
        locations {
          id
          name
          type
          phoneNo
          lat
          long
          street1
          street2
          countryName
          stateName
          cityName
          pincode
        }
      }
    }
  }
`;

export const JOIN_ORGANIZATION = gql`
  mutation joinOrganization($orgId: String!) {
    joinOrganization(orgId: $orgId) {
      id
    }
  }
`;

export const MERGE_ORGANIZATION_REQUEST = gql`
  mutation mergeOrganizationRequest(
    $userId: String!
    $orgId: String!
    $mergeOrgId: String!
  ) {
    mergeOrganizationRequest(
      orgId: $orgId
      userId: $userId
      mergeOrgId: $mergeOrgId
    ) {
      id
    }
  }
`;

export const MERGE_ORGANIZATION = gql`
  mutation mergeOrganization(
    $mergeOrgId: String!
    $orgId: String!
    $userId: String!
  ) {
    mergeOrganization(orgId: $orgId, mergeOrgId: $mergeOrgId, userId: $userId) {
      message
    }
  }
`;

export const CANCEL_MERGE_REQUEST = gql`
  mutation mergeOrganizationRequestCancelByUser(
    $userId: String!
    $orgId: String!
  ) {
    mergeOrganizationRequestCancelByUser(userId: $userId, orgId: $orgId) {
      id
    }
  }
`;

export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription($recievedId: String!) {
    sendNotificationForBid(recievedId: $recievedId) {
      id
      message
      type
    }
  }
`;
